<template>
    <v-sheet class="">
        <v-row class="pa-0 align-center" no-gutters>
            <span class="fontOneToOne font-weight-bold" style="padding-bottom: 1px;">
                {{ $moment(dotMthDt, 'YYYY.MM').format('YYYY년 MM월') }}
            </span>
            <v-spacer></v-spacer>
            <v-btn class="" @click="prevAct" icon>
                <CmmDrawIcon type="ic_prev" size="20"></CmmDrawIcon>
            </v-btn>
            <v-btn class="mr-1" @click="nxtAct" icon>
                <CmmDrawIcon type="ic_nxt" size="20"></CmmDrawIcon>
            </v-btn>
            <v-btn class="" @click="$store.commit('setPickDtMdl', true)" icon>
                <CmmDrawIcon type="ic_calendar" size="20"></CmmDrawIcon>
            </v-btn>
        </v-row>
    </v-sheet>
</template>

<script>
import CmmDrawIcon from './CmmDrawIcon.vue';

export default {
    name: 'AppYYMM',

    components: {
        CmmDrawIcon,
    },

    props: {
        aplyYyMm: { type: String, default: '' },
        aplyMinDt: { type: String, default: '' },
        aplyMaxDt: { type: String, default: '' },
    },

    created: function(){

    },

    mounted: function(){
        this.$nextTick(function () {
            this.$store.commit('setPickDtMdlTyp', 'YYMM')
            
            if(this.aplyYyMm != ''){
                this.dotMthDt = this.$moment(this.aplyYyMm, 'YYYYMM', true).format('YYYY.MM')
                this.hypMthDt = this.$moment(this.aplyYyMm, 'YYYYMM', true).format('YYYY-MM')
                this.$store.commit('setPickDt', this.hypMthDt)
            }
            else{
                this.dotMthDt = this.$store.getters.getPrsntDt('yyyy.mm')
                this.hypMthDt = this.$store.getters.getPrsntDt('yyyy-mm')
            }

            if(this.aplyMinDt != '')
                this.$store.commit('setPickDtMdlMin', this.aplyMinDt)
            if(this.aplyMaxDt != '')
                this.$store.commit('setPickDtMdlMax', this.aplyMaxDt)
        })
    },

    computed: {
        getPickDt: function () {
            return this.$store.state.pickDt
        },
    },

    watch:{
        getPickDt: function (v) {
            if(!(this.$moment(v, 'YYYY-MM', true).format('YYYY.MM') == 'Invalid date')){
                this.dotMthDt = this.$moment(v, 'YYYY-MM', true).format('YYYY.MM')
                this.hypMthDt = v
                this.transDt()
            }
        },
        'aplyYyMm': function () {
            if(this.aplyYyMm != '' && this.aplyYyMm != this.hypMthDt){
                this.dotMthDt = this.$moment(this.aplyYyMm, 'YYYYMM', true).format('YYYY.MM')
                this.hypMthDt = this.$moment(this.aplyYyMm, 'YYYYMM', true).format('YYYY-MM')
                this.$store.commit('setPickDt', this.hypMthDt)
            }
        },
        'aplyMinDt': function () {
            if(this.aplyMinDt != '')
                this.$store.commit('setPickDtMdlMin', this.aplyMinDt)
            else
                this.$store.commit('setPickDtMdlMin', '')
        },
        'aplyMaxDt': function () {
            if(this.aplyMaxDt != '')
                this.$store.commit('setPickDtMdlMax', this.aplyMaxDt)
            else
                this.$store.commit('setPickDtMdlMax', '')
        },
    },
        
    methods: {
        prevAct: function () {
            if(this.aplyMinDt != ''){
                if(this.$moment(this.aplyMinDt).diff(this.hypMthDt, 'months') < 0){
                    this.dotMthDt = this.$moment(this.dotMthDt, 'YYYY.MM', true).subtract(1, 'months').format('YYYY.MM')
                    this.hypMthDt = this.$moment(this.hypMthDt, 'YYYY-MM', true).subtract(1, 'months').format('YYYY-MM')
                }
            }
            else{
                this.dotMthDt = this.$moment(this.dotMthDt, 'YYYY.MM', true).subtract(1, 'months').format('YYYY.MM')
                this.hypMthDt = this.$moment(this.hypMthDt, 'YYYY-MM', true).subtract(1, 'months').format('YYYY-MM')
            }
            this.transDt()
        },
        nxtAct: function () {
            if(this.aplyMaxDt != ''){
                if(this.$moment(this.aplyMaxDt).diff(this.hypMthDt, 'days') > 0){
                    this.dotMthDt = this.$moment(this.dotMthDt, 'YYYY.MM', true).add(1, 'months').format('YYYY.MM')
                    this.hypMthDt = this.$moment(this.hypMthDt, 'YYYY-MM', true).add(1, 'months').format('YYYY-MM')
                }
            }
            else{
                this.dotMthDt = this.$moment(this.dotMthDt, 'YYYY.MM', true).add(1, 'months').format('YYYY.MM')
                this.hypMthDt = this.$moment(this.hypMthDt, 'YYYY-MM', true).add(1, 'months').format('YYYY-MM')
            }
            this.transDt()
        },
        transDt: function () {
            this.$emit('sltDotDt', this.dotMthDt)
            this.$emit('sltHypDt', this.hypMthDt)
        },
    },

    data: () => ({
        dotMthDt: '',
        hypMthDt: '',
    }),
};
</script>